import redshiftLogo from '../../assets/destinationLogos/redshiftLogo.svg';
import sigmaLogo from '../../assets/destinationLogos/sigmaLogo.svg';
import snowflakeLogo from '../../assets/destinationLogos/snowflakeLogo.svg';
import SigmaDestinationConfig from '../components/SigmaDestinationConfig';

export const destinationList = {
    redshift: {
        name: 'Redshift',
        destination: 'redshift',
        logo: redshiftLogo,
        default: true,
        baseUrl: ({ slug }) =>
            `https://gw-data.goodwaygroup.com/queries/4272/source?p_activities_view=${slug}_activities&p_performance_view=${slug}_performance&p_reach_view=${slug}_reach`,
    },
    snowflake: {
        name: 'Snowflake',
        destination: 'snowflake',
        logo: snowflakeLogo,
        default: false,
        baseUrl: () => '', // Snowflake has no Redash preview URL - not clickable
    },
    sigma: {
        name: 'Sigma (Redshift)',
        initialize: destination => {
            return {
                name: `Sigma (${destination?.displayName})`,
                externalTemplate: destination?.externalTemplate,
            };
        },
        logo: sigmaLogo,
        baseUrl: ({ destinationConfig }) => destinationConfig.externalUrl,
        details: SigmaDestinationConfig,
    },
    sigma_snowflake: {
        name: 'Sigma (Snowflake)',
        initialize: destination => {
            return {
                name: `Sigma Snowflake (${destination?.displayName})`,
                externalTemplate: destination?.externalTemplate,
            };
        },
        logo: sigmaLogo,
        baseUrl: ({ destinationConfig }) => destinationConfig.externalUrl,
        details: SigmaDestinationConfig,
    },
};

export const isSigmaDestination = destination =>
    destination === 'sigma' || destination === 'sigma_snowflake';
